var fetching = false;
var page = 1;
let offset = 0;
let finished = false;

function startFetching() {
  fetching = true;
  const loading = document.querySelector(".infinity-loading");
  loading.classList.remove("hidden");
}
function finishFetching() {
  fetching = false;
  const loading = document.querySelector(".infinity-loading");
  loading.classList.add("hidden");
}

async function fetchContent(page) {
  const linesPerPage = 2;
  const perPage = linesPerPage * 4;
  const url = `${window.location.origin}/wp-json/wp/v2/guia-de-empresas?per_page=${perPage}&page=${page}`;
  startFetching();
  const content = await fetch(url)
    .then((con) => {
      if (con.status === 200) {
        return con;
      }
      finished = true;
      return { json: () => [] };
    })
    .then((r) => r.json());
  finishFetching();

  return content;
}

function createSolutionCard(solution) {
  const text = solution["digital_solution"];
  const href = solution["link"];
  const title = solution["title"]["rendered"];
  const bg = solution["image_header_archive"];
  const defaultBg = `${window.location.origin}/wp-content/themes/digitalks/assets/images/defaultBG.jpg`;
  const src = /src="([^"]+)"/.exec(solution.thumbnail);
  const div = document.createElement("div");
  div.classList.add("solutions-item");
  div.innerHTML = `  <div class="solutions-item__background">
  <a href="${href}">
      <img width="250" height="150"
          src="${bg || defaultBg}"
          class="attachment-full size-full" alt="background ${title}" loading="lazy">
  </a>
</div>


<div class="solutions-item__logo">
  <a href="${href}">
      <img width="120" height="70"
          ${src}
          class="logo-image" alt="logo ${title}" loading="lazy ">
  </a>
</div>


<p class="solutions-item__description">
  ${text}
</p>


<a href="${href}" class="solutions-item__button" role="button">

      SAIBA MAIS

</a>`;
  return div;
}

async function appendSolutionCards() {
  if (!finished) {
    const content = await fetchContent(page);
    content.forEach((solution) => {
      const solutionCard = createSolutionCard(solution);
      document.querySelector(".solutions-container").appendChild(solutionCard);
    });
    getOffSet();
    page += 1;
  } else {
    document.querySelector(".finish-message").classList.remove("hidden");
    window.removeEventListener("scroll", onScroll);
  }
}

async function populateFirstPage() {
  appendSolutionCards();
}

function getOffSet() {
  const bodyRect = document.body.getBoundingClientRect();
  const element = document.querySelector(".btn-s");
  const elemRect = element.getBoundingClientRect();
  const buttonOffset = elemRect.top - bodyRect.top;
  offset = buttonOffset;
}

function onScroll() {
  if (pageYOffset >= offset - 400 && pageYOffset <= offset && !fetching) {
    appendSolutionCards();
  }
}

// window.addEventListener("load", () => {
//   if (window.location.pathname === "/guia-de-solucoes/") {
//     getOffSet();
//     populateFirstPage();

//     window.addEventListener("scroll", onScroll);
//   }
// });
